<template>
    <div class="password-reset">
        <div class="header-text">
            <h1>Password Reset</h1>
        </div>
        <div class="auth-content">
            <errors :errors="states.errors"/>
            <div v-if="success" class="alert alert-success">Your password was successfully updated</div>

            <form @submit.prevent="submitForm">
                <div class="form-group">
                    <input
                        v-model="formData.email"
                        :disabled="states.loading"
                        :readonly="emailReadOnly"
                        :autofocus="!emailReadOnly"
                        type="email"
                        class="form-control"
                        placeholder="Email Address"
                        required
                    >
                </div>
                <div class="form-group">
                    <input
                        v-model="formData.password"
                        :disabled="states.loading"
                        :autofocus="emailReadOnly"
                        type="password"
                        class="form-control"
                        placeholder="New password"
                        required
                    >
                </div>
                <div class="form-group">
                    <input
                        v-model="formData.password_confirmation"
                        :disabled="states.loading"
                        type="password"
                        class="form-control"
                        placeholder="Confirm new password"
                        required
                    >
                </div>
                <div class="form-buttons">
                    <button :disabled="states.loading" type="submit" class="btn btn-email">
                        <template v-if="states.loading && typeof states.loading === 'string'">
                            <i class="fa fa-spinner fa-spin"/> {{ states.loading }}
                        </template>
                        <template v-else>
                            Reset password
                        </template>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import Errors from '../../components/auth/Errors';
    import AuthRepository from '../../repositories/AuthRepository';
    import { normaliseErrors } from '../../modules/error-handlers';

    export default {
        name: 'password-reset',

        components: { Errors },

        data() {
            return {
                formData: {
                    email: window.YPS.user.email,
                    password: '',
                    password_confirmation: '',
                },
                states: {
                    errors: [],
                    loading: false,
                    success: false,
                },
            };
        },

        computed: {
            token() {
                return window.location.pathname.split('/').pop();
            },

            emailReadOnly() {
                return Boolean(this.formData.email);
            },
        },

        methods: {
            /**
             * Send the API request to reset the password
             */
            submitForm() {
                this.states.errors = [];
                this.success = false;
                this.startLoading('Setting new password');

                AuthRepository.resetPassword({
                    token: this.token,
                    ...this.formData,
                }).then(() => {
                    this.success = true;
                }).catch((response) => {
                    this.states.errors = normaliseErrors(response);
                }).finally(() => {
                    this.stopLoading();
                });
            },

            /**
             * Set the loading state with an optional message
             *
             * @param {string|boolean} message
             */
            startLoading(message = true) {
                this.states.loading = message;
            },

            /**
             * Disable the loading state
             */
            stopLoading() {
                this.states.loading = false;
            },
        },
    };
</script>

<style lang="less" scoped>
    input[type="email"][readonly] {
        background-color: #dedcdc;
        box-shadow: none;
    }

    .account-errors {
        margin-bottom: 10px;

        ::v-deep p {
            color: #b14646;
            font-size: 13px;
            font-weight: 600;

            i {
                color: #bc5050;
            }
        }
    }
</style>
